// vars
$white: #FFFFFF;
$black: #000000;
$grey: #919EAB;
$grey-light: #ECECEC;
$grey-light-2: #C7C7C7;
$dark-grey: #1F273D;
$light-blue: #F7F8FC;
$blue: #5C6AC4;
$blue-2: #007ACE;

.header {
  &.header1 {
    display: flex;
    justify-content: space-between;
    padding: 25px 20px 25px 20px;
  }
  &.header2 {
    padding: 25px 63px 0px 63px;
    @media only screen and (max-width: 799.98px) {
      padding: 25px 30px 0px 30px
    } 
  }
  &.header3 {
    padding: 25px 63px 25px 63px;
    @media only screen and (max-width: 799.98px) {
      padding: 25px 25px 25px 25px
    }
  }
  &.header4 {
    display: flex;
    justify-content: space-between;
    padding: 0px 63px 35px 63px;
    @media only screen and (max-width: 799.98px) {
      padding: 0px 25px 35px 25px;
    }
  }
}
.rated-wrap {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  &.header2 {
    @media only screen and (max-width: 799.98px) {
      flex-direction: column;
      align-items: center;
      &:after {
        display: none;
      }
    } 
  }
  &.header2.show-separation {
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      width: 1px;
      height: 100%;
      background-color: $grey-light;
      transform: translateX(-50%);
      @media only screen and (max-width: 799.98px) {
        &:after {
          display: none;
        }
      } 
    }
  }
  &.header4 {
    display: flex;
    flex-direction: column;
  }
}
.rating-wrap {
  &.header1 {
    position: relative;
  }
  &.header2 {
    display: flex;
    flex-direction: column;
  }
  &.header3 {
    display: flex;
    flex-direction: column;
  }
}
.rating-btn {
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
  position: relative;
  padding: 0;
}
.rating-text {
  font-size: 14px;
  font-weight: 400;
  color: $grey;
}
.top-title {
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  color: $grey;
  margin-bottom: 25px;
}
.star-title {
  width: 9px;
  height: 9px;
  margin-right: 9px;
}
.rating-title {
  margin: 0;
  &.header4 {
    font-size: 18px;
    font-weight: 500;
    color: $black;
  }
}
.rated {
  margin-left: 20px;
  font-size: 14px;
  font-weight: 700;
  color: $grey;
}
.rating-breakdown {
  &.header1{
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    color: $grey;
    font-size: 14px;
    background-color: white;
    transform: translateY(40px);
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    padding: 0;
    margin: 0;
    transition: opacity 0.3s ease;
    border-radius: 4px;
    border: 1px solid transparent;
    flex: none;
    &.show-breakdown {
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      border: 1px solid $grey-light;
      opacity: 1;
      z-index: 1000;
      max-height: 1000px;
      min-width: 326px;
      padding-bottom: 23px;
    }
  }
  &.header2 {
    padding-left: 0;
    list-style: none;
    margin-top: 0;
    margin-bottom: 0;
  }
}
.rating-breakdown-title {
 font-size: 14px;
 font-weight: 700;
 margin-left: 30px;
 color: $dark-grey;
}
.rating-breakdown-score {
  display: flex;
  align-items: center;
  margin: 7px 30px 7px 30px;
}
.rating-breakdown-text {
  margin: 0px 0px 0px 20px;
  font-size: 12px;
}
.score {
  &.header1 {
    margin-left: auto;
  }
  &.header2 {
    margin-top: auto;
    font-size: 14px;
    color: $dark-grey;
    margin-bottom: 0;
    @media only screen and (max-width: 799.98px) {
      margin-bottom: 20px;
    }
  }
  &.header3 {
    color: $black;
    padding-top: 17px;
    margin: 0;
  }
  &.header4 {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: $grey;
    margin: 19px 0px 0px 0px;
  }
}
.score-number {
  &.header2 {
    font-size: 62px;
    line-height: 62px;
  }
  &.header3 {
    font-size: 18px;
    font-weight: 600;
    color: $black;
  }
  &.header4 {
    font-size: 14px;
    font-weight: 700;
    color: $grey;
    margin-left: 17px;
  }
}
.score-slash {
  position: relative;
  width: 1px;
  height: 14px;
  display: block;
  background-color: $grey-light-2;
  margin-left: 12px;
  margin-right: 12px;
}
.score-total {
  &.header2 {
    color: $grey;
    font-size: 14px;
    margin-left: 13px;
    padding-left: 10px;
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      width: 1px;
      height: 14px;
      background-color: $grey-light-2;
      transform: translateY(-50%);
    }
  }
  &.header3 {
    color: $grey;
    font-size: 14px;
    padding-top: 12px;
    margin: 0;
  }
  &.header4 {
    color: $grey;
    font-size: 14px;
    font-weight: 700;
    margin: 0;
    position: relative;
  }
  &.header4.space-left {
    margin-left: 17px;
  }
}
.sort-wrap {
  &.header2 {
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
    margin-bottom: 15px;
    @media only screen and (max-width: 799.98px) {
      justify-content: center;
    }
  }
  &.header3 {
    margin-top: 30px;
  }
  &.header4 {
    margin-top: auto;
  }
}

.sorting {
  display: inline-flex;
  align-items: center;
  position: relative;
  flex: none;
  &.header4 {
    border-radius: 4px;
    margin-top: auto;
  }
}
.sort-title {
  font-size: 14px;
  font-weight: 700;
  color: $grey;
  &.header2 {
    font-size: 12px;
    font-weight: 700;
    color: $black;
  }
  &.header3 {
    font-size: 12px;
    font-weight: 700;
    color: $black;
  }
  &.header4 {
    font-size: 14px;
    font-weight: 700;
    color: $blue-2;
  }
}
.sort-btn {
  background-color: transparent;
  border: none;
  color: $grey;
  font-size: 14px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease-out;
  cursor: pointer;
  &.header2 {
    color: $black;
  }
  &.header3 {
    border: 1px solid $grey-light;
    border-radius: 4px;
    padding: 8px 14px 8px 14px;
    margin-left: 10px;
  }
  &.header4 {
    color: $blue-2;
  }
}
.sort-select {
  position: absolute;
  display: block;
  top: 0;
  right: 0;
  color: $grey;
  font-size: 14px;
  background-color: white;
  transform: translateY(30px);
  max-height: 0;
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
  padding: 0;
  margin: 0;
  transition: opacity 0.3s ease;
  border-radius: 4px;
  border: 1px solid transparent;
  flex: none;
  @media only screen and (max-width: 799.98px) {
    &.header2 {
      right: 50%;
      transform: translate(50%, 30px);
    }
  }
  &.show-sort {
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    border: 1px solid $grey-light;
    opacity: 1;
    z-index: 1000;
    max-height: 1000px;
    min-width: 186px;
  }
  &.header3 {
    left: 0;
    right: auto;
    transform: translateY(40px);
  }
}
 
.sort-check {
  width: 12px;
  height: 9px;
  margin-right: 12px;
  path {
    transition: all 0.3s ease-in;
    stroke: transparent;
  }
}
.sort__dropdown-item {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 12px 35px 0px 23px;
  transition: all 0.3s ease-out;
  &:first-of-type {
    padding-top: 23px;
  }
  &:last-of-type {
    padding-bottom: 23px;
  }
  &.active {
    color: #626C75;
    .sort-check {
      transition: all 0.4s ease-out;
      path {
        stroke: $grey;
      }
    }
  }
  &:hover, &:active, &:focus {
    color: #626C75;
  }
}
.sort-arrow {
  margin-left: 7px;
  width: 9px;
  height: 6px;
  &.header1 {
    @media only screen and (max-width: 799.98px) {
      margin-left: 0;
    }
  }
  &.header2 {
    width: 8px;
    height: 6px;
    margin-left: 15px;
  }
  &.header4 {
    width: 10px;
    height: 6px;
    margin-left: 15px;
    @media only screen and (max-width: 799.98px) {
      margin-left: 0;
    }
  }
}
.sort-arrow-down {
  transform: rotateX(180deg);
}
.rating-row {
  display: flex;
  margin-bottom: 12.2px;
}

.star-score {
  width: 57px;
  margin-bottom: 0;
  margin-top: 0;
  color: $grey-light-2;
  font-size: 12px;
  line-height: 1.4;
}

.progressbar {
  width: 180px;
  height: 15px;
  border-radius: 4px;
  background-color: $light-blue;
  margin: 0px 10px 0 10px;
  position: relative;
}

.progressbar-value {
  top: 0;
  left: 0;
  height: 15px;
  width: 10%;
  display: block;
  border-radius: 4px;
  background-color: $blue;
}

.percent-count {
  color: $blue;
  font-size: 10px;
  margin-top: 0;
  margin-bottom: 0;
  line-height: 1.4;
}

.review-btn {
  display: flex;
  align-items: center;
  border: none;
  background-color: $blue;
  border-radius: 4px;
  cursor: pointer;
  padding: 10px 14px;
  color: $white;
  font-size: 14px;
}
.icon-pen {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  @media only screen and (max-width: 799.98px) {
    margin-right: 0;
  }
}
